<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <div class="class-left">
          <div class="class-header">
            <el-input placeholder="请输入类目名称" v-model="filterText">
            </el-input>
          </div>
          <el-tree
            :data="shopcateArr"
            show-checkbox
            node-key="id"
            :default-expanded-keys="expanded"
            :default-checked-keys="currentNode"
            :props="defaultProps"
            @check-change="handleNodeClick"
            ref="treeRef"
            :filter-node-method="filterNode"
          >
          </el-tree>
        </div>
        <div class="class-right">
          <div class="hea">
            <div class="hea-left">已选({{ list.length }})</div>
            <div class="hea-right" @click="handleClear">清除已选</div>
          </div>
          <div class="list">
            <div class="item" v-for="(item, i) in list" :key="item.id">
              <div class="item-left">{{ item.name }}</div>
              <div class="item-right">
                <img
                  @click="handleRemoveCate(item, i)"
                  src="@/assets/images/basicBusiness/close.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="posi-btn">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确认" }}</div>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  name: "FillIn",
  props: ["dataVal"],
  data() {
    return {
      shopcateArr: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      expanded: [0], //默认展开节点
      currentNode: "", //当前选中节点
      filterText: "",
      list: [],
      cate_ids: [],
      newVal:""
    };
  },
  mounted() {
    
  },
  methods: {
    handleNodeClick(val) {
      //获取选中id
      this.cate_ids = this.$refs.treeRef.getCheckedKeys();
      //   console.log(this.$refs.treeRef.getCheckedKeys());
      //   console.log(this.$refs.treeRef.getCheckedNodes());
      this.list = this.$refs.treeRef.getCheckedNodes();
    },
    // 获取分类列表
    async shopcatelist(flag) {
      let res = await this.$api.shopcatelist();
      if (res.code == 1) {
        let arr = [
          {
            id: 0,
            type: 0,
            name: "所有分类",
            children: [],
            pid: 0,
          },
        ];
        //一级
        res.data.forEach((item, i) => {
          arr[0].children.push({
            id: item.id,
            type: 1,
            pid: item.pid,
            name: item.name,
            children: [],
          });
          //二级
          if (item.twodata.length != 0) {
            item.twodata.forEach((item2, i2) => {
              arr[0].children[i].children.push({
                id: item2.id,
                type: 2,
                pid: item2.pid,
                name: item2.name,
                children: [],
              });
              // //三级
              if (item2.threedata.length != 0) {
                item2.threedata.forEach((item3, i3) => {
                  arr[0].children[i].children[i2].children.push({
                    id: item3.id,
                    type: 3,
                    pid: item3.pid,
                    name: item3.name,
                    fourdata: item3.fourdata,
                  });
                });
              }
            });
          }
        });
        this.shopcateArr = arr;
        this.$nextTick(() => {
          //id设置选中节点
            this.$refs.treeRef.setCurrentKey(this.newVal.cate_ids);
            this.$refs.treeRef.setCheckedNodes(this.newVal.list);
        });
      }
    },
    //清除
    handleClear() {
      this.list = [];
      this.cate_ids = [];
      this.$refs.treeRef.setCheckedKeys([]);
      this.$refs.treeRef.setCheckedNodes([]);
    },
    //删除
    handleRemoveCate(item, i) {
      this.list.splice(i, 1);
      this.cate_ids.splice(i, 1);
      this.$refs.treeRef.setCheckedKeys(this.cate_ids);
      this.$refs.treeRef.setCheckedNodes(this.list);
    },
    //提交
    async handleSubmit() {
      let obj = {
        flag: false,
        submitFlag: true,
        list:this.list,
        cate_ids:this.cate_ids
      };
      this.$emit("addClassflxCell", obj);
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("addClassflxCell", obj);
    },
    filterNode(value, data) {
      console.log(value, data);
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        this.newVal = newVal;
        this.shopcatelist();
        
      },
      deep: true,
    },
    filterText(val) {
      this.$refs.treeRef.filter(val);
    },
  },
};
</script>
    <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 1016px;
  height: 75vh;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  .posi-over {
    display: flex;
    border-bottom: 1px solid #d9d9d9;
    /deep/.class-left {
      width: 50%;
      height: calc(80vh - 235px);
      padding: 21px 41px 0;
      overflow: auto;
      border-right: 1px solid #d9d9d9;
      .class-header {
        margin-bottom: 19px;
      }
      .el-tree-node__content {
        margin-bottom: 10px;
      }
    }
    .class-right {
      height: calc(80vh - 235px);
      padding: 21px 41px 0;
      overflow: auto;
      width: 50%;
      .hea {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        font-weight: 700;
        color: #202224;
        margin-bottom: 28px;
        .hea-right {
          color: #007aff;
          cursor: pointer;
        }
      }
      .list {
        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          font-weight: 500;
          color: #202224;
          margin-bottom: 21px;
          .item-right {
            width: 20px;
            height: 20px;
            cursor: pointer;
          }
          &:hover {
            color: #007aff;
          }
        }
      }
    }
  }
  .posi-btn {
    padding-top: 40px;
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #007aff;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>